import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faSmile,
  faLaughBeam,
  faMeh,
  faFrown,
  faAngry,
  faSurprise,
} from "@fortawesome/free-solid-svg-icons"


const SELECTED_STYLE = 'blue white-shadow white-bg circle-radius'


const ReactionButtons = (props) => (
  <div
    className='flex-container align-spaced smb'
  >
    <div
      className='flex-container flex-dir-column align-center-middle hand-on-hover'
      onClick={() => props.react(1)}
    >
      <FontAwesomeIcon
        icon={faAngry}
        className={`reaction-icon ${props.reaction === 1 ? SELECTED_STYLE : ''}`}
      />
      <h6 className='text-center light'>Angry</h6>
    </div>

    <div
      className='flex-container flex-dir-column align-center-middle hand-on-hover'
      onClick={() => props.react(2)}
    >
      <FontAwesomeIcon
        icon={faLaughBeam}
        className={`reaction-icon ${props.reaction === 2 ? SELECTED_STYLE : ''}`}
      />
      <h6 className='text-center light'>Happy</h6>
    </div>

    <div
      className='flex-container flex-dir-column align-center-middle hand-on-hover'
      onClick={() => props.react(3)}
    >
      <FontAwesomeIcon
        icon={faMeh}
        className={`reaction-icon ${props.reaction === 3 ? SELECTED_STYLE : ''}`}
      />
      <h6 className='text-center light'>Meh</h6>
    </div>

    <div
      className='flex-container flex-dir-column align-center-middle hand-on-hover'
      onClick={() => props.react(4)}
    >
      <FontAwesomeIcon
        icon={faSurprise}
        className={`reaction-icon ${props.reaction === 4 ? SELECTED_STYLE : ''}`}
      />
      <h6 className='text-center light'>Surprise</h6>
    </div>
  </div>
);


export default ReactionButtons;
